import { useState } from 'react';
import { Icon } from '@/components/foundations';
import { TextField, type TextFieldProps } from './TextField';

/** Campo de senha com mostrar/ocultar (login). */
export function PasswordField({ defaultVisible = false, ...props }: Omit<TextFieldProps, 'type' | 'suffix'> & { defaultVisible?: boolean }) {
  const [visible, setVisible] = useState(defaultVisible);
  return (
    <TextField
      icon="lock"
      {...props}
      type={visible ? 'text' : 'password'}
      suffix={
        <button type="button" className="eye" onClick={() => setVisible(!visible)} aria-label={visible ? 'Ocultar senha' : 'Mostrar senha'} aria-pressed={visible}>
          <Icon name="eye" />
        </button>
      }
    />
  );
}
